import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { ScanLine, Loader2 } from 'lucide-react';

export function PDFViewerModal({ open, url, title, loading, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => {
      if (!o) onClose();
    }}>
      <DialogContent className="max-w-4xl h-[85vh] flex flex-col p-4" data-testid="pdf-viewer-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-sm">
            <ScanLine className="w-4 h-4 text-purple-600" /> {title}
          </DialogTitle>
        </DialogHeader>
        {loading && (
          <div className="flex-1 flex items-center justify-center">
            <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
          </div>
        )}
        {url && (
          <iframe
            src={url}
            className="flex-1 w-full rounded border"
            title={title}
            data-testid="pdf-iframe"
          />
        )}
        <DialogFooter className="flex gap-2">
          {url && (
            <a href={url} download={`${title}.pdf`}
              className="inline-flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 underline">
              Descargar PDF
            </a>
          )}
          <Button variant="outline" size="sm" onClick={onClose}>Cerrar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
